import { useQueryClient } from 'react-query';
import { QueryKeys } from '../../../../core/queries/query-keys.constants';
import { convertHyphenated } from '../../../../core/util/string-conversion';
import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useMutationDeleteProjectModule, useQueryGetProjectModuleOptional } from '../../../project-modules/queries';

export interface DeleteProjectModuleModalProps {
  projectId: string;
  projectModuleId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export function DeleteProjectModuleModal(props: DeleteProjectModuleModalProps) {
  const queryClient = useQueryClient();
  const module = useQueryGetProjectModuleOptional(props.projectId, props.projectModuleId);

  const mutation = useMutationDeleteProjectModule();

  const onConfirm = async () => {
    await mutation.mutateAsync({ projectID: props.projectId, moduleID: props.projectModuleId });
    queryClient.invalidateQueries(QueryKeys.SETTINGS);
    props.onSuccess();
  };

  const errorMessage = !module.data
    ? 'Sorry, there was an error loading the Project Module. Please close the modal and try again'
    : undefined;

  return (
    <ConfirmationModal
      title="Delete Project Module?"
      onCancel={props.onCancel}
      onConfirm={onConfirm}
      warning={`Are you sure? You only want to do this if it will not be used ever again, or never was in the first place.`}
      isLoading={module.isLoading || mutation.isLoading}
      content={[convertHyphenated(module.data?.schema.name || '', { capitalizeEachWord: true })]}
      errorMessage={errorMessage}
      noteRequired={false}
      actionButton={{
        label: 'Delete',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel',
        color: 'secondary'
      }}
    />
  );
}
